import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full flex items-center justify-between px-3 py-3 border-b border-badge/30" };
const _hoisted_2 = { class: "w-full flex-1 overflow-y-auto" };
const _hoisted_3 = {
    key: 0,
    class: "p-4 border-b border-badge/30 bg-gray-50"
};
const _hoisted_4 = { class: "text-lg font-semibold text-badge mb-3" };
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    key: 1,
    value: "repair_cost"
};
const _hoisted_9 = {
    key: 2,
    value: "service_fee"
};
const _hoisted_10 = {
    key: 3,
    value: "sale_price"
};
const _hoisted_11 = {
    key: 0,
    class: "text-xs text-amber-600 mt-1"
};
const _hoisted_12 = {
    key: 1,
    class: "text-xs text-amber-600 mt-1"
};
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { class: "md:col-span-2" };
const _hoisted_15 = { class: "flex gap-2 mt-3" };
const _hoisted_16 = { class: "p-4" };
const _hoisted_17 = {
    key: 0,
    class: "flex items-center justify-center"
};
const _hoisted_18 = {
    key: 1,
    class: "text-center text-badge/70 py-8"
};
const _hoisted_19 = {
    key: 2,
    class: "space-y-4"
};
const _hoisted_20 = { class: "p-3 bg-gray-50 rounded-lg border border-badge/30" };
const _hoisted_21 = { class: "flex justify-between items-center" };
const _hoisted_22 = { class: "flex justify-between items-start mb-2" };
const _hoisted_23 = { class: "text-lg font-semibold text-badge" };
const _hoisted_24 = {
    key: 0,
    class: "flex gap-1"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { class: "space-y-1 text-sm" };
const _hoisted_28 = { class: "flex justify-between" };
const _hoisted_29 = { class: "flex justify-between" };
const _hoisted_30 = { class: "text-primary2" };
const _hoisted_31 = { class: "flex justify-between" };
const _hoisted_32 = { class: "text-primary2" };
const _hoisted_33 = { class: "hidden md:block" };
const _hoisted_34 = { class: "w-full" };
const _hoisted_35 = { class: "px-4 py-3 text-sm" };
const _hoisted_36 = { class: "px-4 py-3 text-sm text-badge/70" };
const _hoisted_37 = { class: "px-4 py-3 text-sm" };
const _hoisted_38 = { class: "px-4 py-3 text-center" };
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    key: 1,
    class: "text-gray-400 text-sm"
};
import { ref, watch, onMounted, computed } from 'vue';
import { X, Loader, Pencil, Trash2 } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'transaction-record-dialog',
    props: {
        listingId: {},
        showDialog: { type: Boolean },
        mode: { default: 'normal' }
    },
    emits: ["close-dialog"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const showContent = ref(false);
        const isLoading = ref(false);
        const transactions = ref([]);
        const isEditing = ref(false);
        const editingId = ref(null);
        const form = ref({
            transaction_type: 'buying_price',
            description: '',
            phone_no: '',
            amount: 0,
            transaction_date: '',
        });
        // Helper function to get XSRF token from cookie
        const getXsrfToken = () => {
            const cookie = document.cookie
                .split('; ')
                .find((row) => row.startsWith('XSRF-TOKEN='));
            return cookie ? decodeURIComponent(cookie.split('=')[1]) : '';
        };
        // Check if buying price already exists
        const hasBuyingPrice = computed(() => {
            return transactions.value.some(t => t.transaction_type === 'buying_price');
        });
        // Check if sale price already exists
        const hasSalePrice = computed(() => {
            return transactions.value.some(t => t.transaction_type === 'sale_price');
        });
        // Calculate total profit (sale_price as positive, others as negative)
        const totalProfit = computed(() => {
            return transactions.value.reduce((sum, transaction) => {
                const amount = typeof transaction.amount === 'string' ? parseFloat(transaction.amount) : transaction.amount;
                if (transaction.transaction_type === 'sale_price') {
                    return sum + amount;
                }
                else {
                    return sum - amount;
                }
            }, 0);
        });
        // Watch for dialog visibility
        watch(() => props.showDialog, (newValue) => {
            if (newValue && props.listingId) {
                setTimeout(() => {
                    showContent.value = true;
                }, 100);
                loadTransactions();
                // Set transaction_type to sale_price if mark-as-sold mode
                if (props.mode === 'mark-as-sold') {
                    form.value.transaction_type = 'sale_price';
                    // Check if initialAmount was provided (from listing price)
                    const store = window.manageListingsStore;
                    if (store && store.initialAmount) {
                        form.value.amount = store.initialAmount;
                        // Clear initialAmount after using it so it doesn't persist
                        delete store.initialAmount;
                    }
                }
                // Set default date to current time if form is empty
                if (!form.value.transaction_date) {
                    const now = new Date();
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const day = String(now.getDate()).padStart(2, '0');
                    const hours = String(now.getHours()).padStart(2, '0');
                    const minutes = String(now.getMinutes()).padStart(2, '0');
                    form.value.transaction_date = `${year}-${month}-${day}T${hours}:${minutes}`;
                }
            }
            else if (!newValue) {
                showContent.value = false;
                resetForm();
            }
        });
        // Load transactions from API
        const loadTransactions = async () => {
            if (!props.listingId)
                return;
            isLoading.value = true;
            try {
                const response = await fetch(`/api/v1/transactions/${props.listingId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': getXsrfToken(),
                    },
                    credentials: 'include',
                });
                const data = await response.json();
                if (data.success === 1) {
                    transactions.value = data.result.list || [];
                    // Set default transaction type based on available options
                    // If not in mark-as-sold mode, set to first available option
                    if (props.mode !== 'mark-as-sold') {
                        if (transactions.value.length === 0) {
                            // No transactions: default to buying_price
                            form.value.transaction_type = 'buying_price';
                        }
                        else {
                            // Has transactions: default to repair_cost (first option after filtering)
                            form.value.transaction_type = 'repair_cost';
                        }
                    }
                }
                else {
                    console.error('Failed to load transactions:', data.message);
                }
            }
            catch (error) {
                console.error('Error loading transactions:', error);
            }
            finally {
                isLoading.value = false;
            }
        };
        // Save transaction (create or update)
        const saveTransaction = async () => {
            if (!props.listingId || !form.value.transaction_type || !form.value.amount || !form.value.transaction_date) {
                alert('Please fill in all required fields');
                return;
            }
            // Validate phone_no for sale_price
            if (form.value.transaction_type === 'sale_price' && !form.value.phone_no) {
                alert('Phone number is required for Sale Price');
                return;
            }
            isLoading.value = true;
            try {
                const url = isEditing.value && editingId.value
                    ? `/api/v1/transactions/${props.listingId}/${editingId.value}`
                    : `/api/v1/transactions/${props.listingId}`;
                const method = isEditing.value ? 'PUT' : 'POST';
                // Build payload - only include fields that backend expects
                const payload = {
                    transaction_type: form.value.transaction_type,
                    amount: parseFloat(String(form.value.amount)), // Ensure amount is a number
                    transaction_date: form.value.transaction_date,
                };
                // Only add description if provided
                if (form.value.description && form.value.description.trim()) {
                    payload.description = form.value.description.trim();
                }
                // Only add phone_no for sale_price type
                if (form.value.transaction_type === 'sale_price' && form.value.phone_no) {
                    payload.phone_no = form.value.phone_no.trim();
                }
                console.log('Sending payload:', JSON.stringify(payload, null, 2));
                const response = await fetch(url, {
                    method,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': getXsrfToken(),
                    },
                    credentials: 'include',
                    body: JSON.stringify(payload),
                });
                const data = await response.json();
                if (data.success === 1) {
                    await loadTransactions();
                    resetForm();
                }
                else {
                    alert(data.message || 'Failed to save transaction');
                }
            }
            catch (error) {
                console.error('Error saving transaction:', error);
                alert('Failed to save transaction');
            }
            finally {
                isLoading.value = false;
            }
        };
        // Edit transaction
        const editTransaction = (transaction) => {
            isEditing.value = true;
            editingId.value = transaction.id;
            form.value = {
                transaction_type: transaction.transaction_type,
                description: transaction.description || '',
                phone_no: transaction.phone_no || '',
                amount: transaction.amount,
                transaction_date: transaction.transaction_date.slice(0, 16),
            };
        };
        // Cancel edit
        const cancelEdit = () => {
            resetForm();
        };
        // Delete transaction
        const deleteTransaction = async (transactionId) => {
            if (!props.listingId)
                return;
            if (!confirm('Are you sure you want to delete this transaction record?'))
                return;
            isLoading.value = true;
            try {
                const response = await fetch(`/api/v1/transactions/${props.listingId}/${transactionId}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': getXsrfToken(),
                    },
                    credentials: 'include',
                });
                const data = await response.json();
                if (data.success === 1) {
                    await loadTransactions();
                    if (isEditing.value && editingId.value === transactionId) {
                        resetForm();
                    }
                }
                else {
                    alert(data.message || 'Failed to delete transaction');
                }
            }
            catch (error) {
                console.error('Error deleting transaction:', error);
                alert('Failed to delete transaction');
            }
            finally {
                isLoading.value = false;
            }
        };
        // Reset form
        const resetForm = () => {
            isEditing.value = false;
            editingId.value = null;
            // Determine default transaction type
            let defaultType = 'buying_price';
            if (props.mode === 'mark-as-sold') {
                defaultType = 'sale_price';
            }
            else if (transactions.value.length > 0 && !transactions.value.some(t => t.transaction_type === 'buying_price')) {
                // If transactions exist but no buying price, default to repair_cost
                defaultType = 'repair_cost';
            }
            else if (transactions.value.length > 0) {
                // If transactions exist and buying price exists, default to repair_cost
                defaultType = 'repair_cost';
            }
            // Set default date to current time
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
            form.value = {
                transaction_type: defaultType,
                description: '',
                phone_no: '',
                amount: 0,
                transaction_date: currentDateTime,
            };
        };
        // Close dialog
        const closeDialog = () => {
            showContent.value = false;
            setTimeout(() => {
                emit('close-dialog');
            }, 100);
        };
        // Format amount
        const formatAmount = (amount) => {
            const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
            return numAmount.toFixed(2);
        };
        // Format date
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-MY', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        };
        // Format transaction type
        const formatTransactionType = (type, phone_no = null) => {
            const types = {
                buying_price: 'Buying Price',
                repair_cost: 'Repair Cost',
                service_fee: 'Service Fee',
                sale_price: 'Sale Price',
            };
            const baseType = types[type] || type;
            // Append phone number for sale_price
            if (type === 'sale_price' && phone_no) {
                return `${baseType} (${phone_no})`;
            }
            return baseType;
        };
        // Set default date on mount
        onMounted(() => {
            const now = new Date();
            // Format to local datetime string (YYYY-MM-DDTHH:mm)
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            form.value.transaction_date = `${year}-${month}-${day}T${hours}:${minutes}`;
        });
        return (_ctx, _cache) => {
            return (__props.showDialog)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed left-0 top-0 h-[var(--safe-height)] w-full bg-black/30 backdrop-blur-sm flex items-center justify-center z-[1001]",
                    onClick: _cache[7] || (_cache[7] = ($event) => (closeDialog()))
                }, [
                    _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100 transform",
                        "enter-from-class": "opacity-0 scale-95",
                        "enter-to-class": "opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75 transform",
                        "leave-from-class": "opacity-100 scale-100",
                        "leave-to-class": "opacity-0 scale-95"
                    }, {
                        default: _withCtx(() => [
                            (showContent.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "w-[90%] h-[90%] bg-white rounded-[20px] border border-badge overflow-auto scroll-smooth flex flex-col",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_1, [
                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-2xl font-medium text-badge" }, "Transaction Records", -1)),
                                        _createVNode(_unref(X), {
                                            class: "size-8 text-badge cursor-pointer",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (closeDialog()))
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_2, [
                                        (!hasSalePrice.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                _createElementVNode("div", _hoisted_4, _toDisplayString(isEditing.value ? 'Edit Transaction' : (__props.mode === 'mark-as-sold' ? 'Mark as Sold' : 'Add New Transaction')), 1),
                                                _createElementVNode("div", _hoisted_5, [
                                                    _createElementVNode("div", null, [
                                                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-1" }, "Type", -1)),
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.value.transaction_type) = $event)),
                                                            class: _normalizeClass(["w-full p-2 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 text-primary2", { 'bg-gray-100': hasBuyingPrice.value && !isEditing.value && form.value.transaction_type !== 'buying_price', 'bg-gray-100 cursor-not-allowed': __props.mode === 'mark-as-sold' }]),
                                                            disabled: __props.mode === 'mark-as-sold'
                                                        }, [
                                                            (transactions.value.length === 0)
                                                                ? (_openBlock(), _createElementBlock("option", {
                                                                    key: 0,
                                                                    value: "buying_price",
                                                                    disabled: hasBuyingPrice.value && !isEditing.value
                                                                }, " Buying Price ", 8, _hoisted_7))
                                                                : _createCommentVNode("", true),
                                                            (transactions.value.length > 0)
                                                                ? (_openBlock(), _createElementBlock("option", _hoisted_8, "Repair Cost"))
                                                                : _createCommentVNode("", true),
                                                            (transactions.value.length > 0)
                                                                ? (_openBlock(), _createElementBlock("option", _hoisted_9, "Service Fee"))
                                                                : _createCommentVNode("", true),
                                                            (__props.mode === 'mark-as-sold')
                                                                ? (_openBlock(), _createElementBlock("option", _hoisted_10, "Sale Price"))
                                                                : _createCommentVNode("", true)
                                                        ], 10, _hoisted_6), [
                                                            [_vModelSelect, form.value.transaction_type]
                                                        ]),
                                                        (__props.mode === 'mark-as-sold')
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Transaction type is locked to Sale Price "))
                                                            : (transactions.value.length === 0)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Add Buying Price first before adding other transaction types "))
                                                                : _createCommentVNode("", true)
                                                    ]),
                                                    (form.value.transaction_type === 'sale_price')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-1" }, "Phone No *", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.value.phone_no) = $event)),
                                                                type: "text",
                                                                class: "w-full p-2 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 text-primary2",
                                                                placeholder: "Enter phone number"
                                                            }, null, 512), [
                                                                [_vModelText, form.value.phone_no]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", null, [
                                                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-1" }, "Amount (RM)", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.amount) = $event)),
                                                            type: "number",
                                                            step: "0.01",
                                                            min: "0",
                                                            class: "w-full p-2 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 text-primary2",
                                                            placeholder: "0.00"
                                                        }, null, 512), [
                                                            [
                                                                _vModelText,
                                                                form.value.amount,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-1" }, "Date", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.transaction_date) = $event)),
                                                            type: "datetime-local",
                                                            class: "w-full p-2 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 text-primary2"
                                                        }, null, 512), [
                                                            [_vModelText, form.value.transaction_date]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-1" }, "Description", -1)),
                                                        _withDirectives(_createElementVNode("textarea", {
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.description) = $event)),
                                                            rows: "2",
                                                            class: "w-full p-2 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 text-primary2",
                                                            placeholder: "Enter description..."
                                                        }, null, 512), [
                                                            [_vModelText, form.value.description]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_15, [
                                                    (isEditing.value)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            onClick: cancelEdit,
                                                            class: "flex-1 bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600 transition-colors"
                                                        }, " Cancel "))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("button", {
                                                        onClick: saveTransaction,
                                                        class: "flex-1 bg-primary2 text-white py-2 rounded-lg hover:bg-primary2/80 transition-colors"
                                                    }, _toDisplayString(isEditing.value ? 'Update' : 'Add') + " Transaction ", 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_16, [
                                            (isLoading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createVNode(_unref(Loader), { class: "size-8 animate-spin text-badge" })
                                                ]))
                                                : (transactions.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, " No transaction records found. "))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _createElementVNode("div", _hoisted_20, [
                                                            _createElementVNode("div", _hoisted_21, [
                                                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "font-semibold text-badge" }, "Total Profit:", -1)),
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["font-bold", totalProfit.value >= 0 ? 'text-green-600' : 'text-red-600'])
                                                                }, _toDisplayString(totalProfit.value >= 0 ? '+' : '-') + " RM " + _toDisplayString(formatAmount(Math.abs(totalProfit.value))), 3)
                                                            ])
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: transaction.id,
                                                                class: "bg-white border border-badge/30 rounded-lg p-3 shadow-sm md:hidden"
                                                            }, [
                                                                _createElementVNode("div", _hoisted_22, [
                                                                    _createElementVNode("div", _hoisted_23, _toDisplayString(formatTransactionType(transaction.transaction_type, transaction.phone_no)), 1),
                                                                    (__props.mode !== 'mark-as-sold')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                            _createElementVNode("button", {
                                                                                onClick: ($event) => (editTransaction(transaction)),
                                                                                class: "p-1 text-blue-500 hover:bg-blue-50 rounded"
                                                                            }, [
                                                                                _createVNode(_unref(Pencil), { class: "size-4" })
                                                                            ], 8, _hoisted_25),
                                                                            _createElementVNode("button", {
                                                                                onClick: ($event) => (deleteTransaction(transaction.id)),
                                                                                class: "p-1 text-red-500 hover:bg-red-50 rounded"
                                                                            }, [
                                                                                _createVNode(_unref(Trash2), { class: "size-4" })
                                                                            ], 8, _hoisted_26)
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_27, [
                                                                    _createElementVNode("div", _hoisted_28, [
                                                                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-badge/70" }, "Amount:", -1)),
                                                                        _createElementVNode("span", {
                                                                            class: _normalizeClass(["font-medium", transaction.transaction_type === 'sale_price' ? 'text-green-600' : 'text-red-600'])
                                                                        }, "RM " + _toDisplayString(formatAmount(transaction.amount)), 3)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_29, [
                                                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-badge/70" }, "Date:", -1)),
                                                                        _createElementVNode("span", _hoisted_30, _toDisplayString(formatDate(transaction.transaction_date)), 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_31, [
                                                                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-badge/70" }, "Desc:", -1)),
                                                                        _createElementVNode("span", _hoisted_32, _toDisplayString(transaction.description), 1)
                                                                    ])
                                                                ])
                                                            ]));
                                                        }), 128)),
                                                        _createElementVNode("div", _hoisted_33, [
                                                            _createElementVNode("table", _hoisted_34, [
                                                                _cache[18] || (_cache[18] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                                                                    _createElementVNode("tr", null, [
                                                                        _createElementVNode("th", { class: "px-4 py-2 text-left text-sm font-medium text-badge" }, "Type"),
                                                                        _createElementVNode("th", { class: "px-4 py-2 text-left text-sm font-medium text-badge" }, "Description"),
                                                                        _createElementVNode("th", { class: "px-4 py-2 text-right text-sm font-medium text-badge" }, "Amount (RM)"),
                                                                        _createElementVNode("th", { class: "px-4 py-2 text-left text-sm font-medium text-badge" }, "Date"),
                                                                        _createElementVNode("th", { class: "px-4 py-2 text-center text-sm font-medium text-badge" }, "Actions")
                                                                    ])
                                                                ], -1)),
                                                                _createElementVNode("tbody", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                                                                        return (_openBlock(), _createElementBlock("tr", {
                                                                            key: transaction.id,
                                                                            class: "border-b border-badge/20 hover:bg-gray-50 text-primary2"
                                                                        }, [
                                                                            _createElementVNode("td", _hoisted_35, _toDisplayString(formatTransactionType(transaction.transaction_type, transaction.phone_no)), 1),
                                                                            _createElementVNode("td", _hoisted_36, _toDisplayString(transaction.description || '-'), 1),
                                                                            _createElementVNode("td", {
                                                                                class: _normalizeClass(["px-4 py-3 text-sm text-right font-medium", transaction.transaction_type === 'sale_price' ? 'text-green-600' : 'text-red-600'])
                                                                            }, _toDisplayString(formatAmount(transaction.amount)), 3),
                                                                            _createElementVNode("td", _hoisted_37, _toDisplayString(formatDate(transaction.transaction_date)), 1),
                                                                            _createElementVNode("td", _hoisted_38, [
                                                                                (__props.mode !== 'mark-as-sold')
                                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                        _createElementVNode("button", {
                                                                                            onClick: ($event) => (editTransaction(transaction)),
                                                                                            class: "p-1 text-blue-500 hover:bg-blue-50 rounded mr-1"
                                                                                        }, [
                                                                                            _createVNode(_unref(Pencil), { class: "size-4" })
                                                                                        ], 8, _hoisted_39),
                                                                                        _createElementVNode("button", {
                                                                                            onClick: ($event) => (deleteTransaction(transaction.id)),
                                                                                            class: "p-1 text-red-500 hover:bg-red-50 rounded"
                                                                                        }, [
                                                                                            _createVNode(_unref(Trash2), { class: "size-4" })
                                                                                        ], 8, _hoisted_40)
                                                                                    ], 64))
                                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_41, "-"))
                                                                            ])
                                                                        ]));
                                                                    }), 128))
                                                                ])
                                                            ])
                                                        ])
                                                    ]))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
